
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.531 7.945v4.5h-1.11v-4.5H.165V6.906h4.258v-4.5h1.11v4.5h4.257v1.04H5.531zM.164 1.335V.298H9.79v1.039H.164z","fill":"currentColor"}})])
          )
        }
      }
    